const initialState = {
  fetching: false,
};

export default function completedTaskReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'COMPLETED_TASKS_FETCHING':
      return { ...currentState, fetching: true };
    case 'COMPLETED_TASKS_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
